<template>
  <van-popup class="gba_pop" v-model="show" closeable>
    <div class="gba_wrap">
      <img src="@/assets/img/live/live-gba.jpg">
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "live-gba",
  components:{
  },
  data() {
    return {
      show:false,
    } 
  },
  methods:{
    open(){
      this.show=true;
    }
  }
};
</script>

<style lang="scss" scoped>
.gba_pop{
  width: 5.3rem;
  height: 8rem;
  transform: translate(-50%,-50%);
  border-radius: 0.05rem;
  position: fixed;
  // overflow:auto;
  .gba_wrap{
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: absolute;
    top: 0;
    left: 0;
    img{
      display: block;
      width: 100%;
    }
  }
  
  &::v-deep .van-popup__close-icon--top-right{
    width: 0.44rem;
    height: 0.44rem;
    color: #fff;
    right: 0.3rem;
    top: 0.3rem;
  }
  
}

</style>